import React, { FC } from "react";

import { SerializedStyles } from "@emotion/react";

import { unitPageLayoutContentBody } from "@components/UnitPageLayout/styles";

export type ContentBodyProps = {
  noPadding?: boolean;
  children?: React.ReactNode;
};

const ContentBody: FC<ContentBodyProps> = ({ noPadding = false, children }) => {
  return <div css={(): SerializedStyles => unitPageLayoutContentBody(noPadding)}>{children}</div>;
};

export default ContentBody;
